import { Box, Typography } from '@mui/material';
import EmailStatus from 'src/sections/Email/EmailStatus';

const EmailStatusChart = () => {
  return (
    <>
      <Box
        sx={{
          padding: '64px 20px 0px 20px',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          marginLeft: '55px',
          backgroundColor: '#f0f0f0',
        }}
      >
        <EmailStatus />
      </Box>
    </>
  );
};

export default EmailStatusChart;
